module.exports = __webpack_public_path__ + "img/code.7d41bb9d.jpeg";